import request from "@/utils/request";
// 根据数据字典组标识查询数据字典返回lable,value.....
export function getByGroupIdentification(data) {
  return request({
    url: "/pom/commonDictionary/queryByGroupIdentification/" + data,
    method: "get"
  });
}

// 采购已接单统计
export function getMesPurchaseOrderCount(data) {
  return request({
    url: "/mes/mesPurchaseOrder/purchaseOrderCount",
    method: "post",
    data: data
  });
}

// 面料采购列表
export function materialPurchaseOrderPage(data, type) {
  return request({
    url: "/mes/materialPurchaseOrder/materialPurchaseOrderPage?type=" + type,
    method: "POST",
    data: data
  });
}

// 面料采购统计
export function getMaterialPurchaseCount() {
  return request({
    url: "/mes/materialPurchaseOrder/materialPurchaseCount",
    method: "GET"
  });
}

// 获取面料采购-凭证详情
export function getMaterialPurchaseDetail(data) {
  return request({
    url: "/mes/materialPurchaseOrder/getMaterialPurchaseDetail/" + data,
    method: "POST"
  });
}

// 提交上传凭证
export function handleUploadCertificate(data) {
  return request({
    url: "/mes/materialPurchaseOrder/uploadCertificate",
    method: "POST",
    data: data
  });
}

// 批量保存更新图片附件
export function saveCommonAttachments(data, plateOrderId) {
  return request({
    url: "/mes/commonAttachment/saveCommonAttachments/" + plateOrderId,
    method: "POST",
    data: data
  });
}

// 获取面料采购-批色审查结果列表
export function getMaterialPurchaseApproveColor(id) {
  return request({
    url: "/mes/materialPurchaseOrder/getMaterialPurchaseApproveColor/" + id,
    method: "POST"
  });
}

// 获取批色审批结果列表
export function getMaterialPurchase(id) {
  return request({
    url: "/mes/materialPurchaseOrder/getMaterialPurchase/" + id,
    method: "POST"
  });
}

// 二次工艺加工列表
export function getPurchaseSecondaryProcessPage(data) {
  return request({
    url: "/mes/mesPurchaseSecondaryProcess/purchaseSecondaryProcessPage",
    method: "POST",
    data: data
  });
}

// 二次工艺加工统计
export function getPurchaseSecondaryProcessCount() {
  return request({
    url: "/mes/mesPurchaseSecondaryProcess/purchaseSecondaryProcessCount",
    method: "POST"
  });
}

// 获取二次工艺-凭证详情
export function getSecondaryProcessDetail(id) {
  return request({
    url: "/mes/mesPurchaseSecondaryProcess/getSecondaryProcessDetail/" + id,
    method: "GET"
  });
}

// 保存二次工艺-工艺完成
export function getSecondaryProcessComplete(data) {
  return request({
    url: "/mes/mesPurchaseSecondaryProcess/secondaryProcessComplete",
    method: "POST",
    data: data
  });
}

// 二次工艺-审查结果
export function getSecondaryProcessApprove(url, id) {
  return request({
    url: url + "/" + id,
    method: "POST"
  });
}

// 产前样制作列表
export function getPrenatalSamplePage(data) {
  return request({
    url: "/mes/mesPrenatalSample/prenatalSamplePage",
    method: "POST",
    data: data
  });
}

// 完成产前样
export function getCompletePrenatalSample(data) {
  return request({
    url: "/mes/mesPrenatalSample/completePrenatalSample",
    method: "POST",
    data: data
  });
}

// 产前样审核记录
export function getMesPrenatalSampleApprove(id) {
  return request({
    url: "/mes/mesPrenatalSample/getMesPrenatalSampleApprove/" + id,
    method: "GET"
  });
}

// 获取产前样制作尺码数量
export function getPrenatalSampleProductionSize(id) {
  return request({
    url: "/mes/mesMeansProduction/getMeansProductionSize/" + id,
    method: "GET"
  });
}

// 产前样统计
export function getPrenatalSampleCount() {
  return request({
    url: "/mes/mesPrenatalSample/prenatalSampleCount",
    method: "GET"
  });
}

// 审核产前样
export function reviewResult(data) {
  return request({
    url: "/mes/mesPrenatalSample/reviewResult",
    method: "POST",
    data: data
  });
}

// 裁床统计
export function getCuttingBedCount() {
  return request({
    url: "/mes/mesCuttingBed/cuttingBedCount",
    method: "GET"
  });
}

// 裁床列表
export function getCuttingBedPage(data) {
  return request({
    url: "/mes/mesCuttingBed/cuttingBedPage",
    method: "POST",
    data: data
  });
}

// 获取裁床尺码详情
export function getCuttingBedDetail(id) {
  return request({
    url: "/mes/mesCuttingBed/getCuttingBedDetail/" + id,
    method: "GET"
  });
}

// 提交裁床数量
export function submitCuttingBed(data) {
  return request({
    url: "/mes/mesCuttingBed/submitCuttingBed",
    method: "POST",
    data: data
  });
}

// qc查询统计
export function getCheckOrderCount(data) {
  return request({
    url: "/mes/mesCheckOrder/checkOrderCount",
    method: "POST",
    data: data
  });
}

// QC查货-列表
export function getQualityControlQuery(data) {
  return request({
    url: "/mes/mesCheckOrder/checkOrderPage",
    method: "POST",
    data: data
  });
}

// QC查货结果-操作记录
export function getCheckOrderDetail(checkOrderId) {
  return request({
    url: "/mes/mesCheckOrder/getCheckOrderDetail/" + checkOrderId,
    method: "GET"
  });
}

// 发货-单据状态统计
export function getDeliverCount() {
  return request({
    url: "/mes/mesDeliveryOrder/getDeliverCount",
    method: "GET"
  });
}

// 生产订单待发货列表
export function purchaseOrderDeliveryPage(data) {
  return request({
    url: "/mes/mesDeliveryOrder/purchaseOrderDeliveryPage",
    method: "POST",
    data: data
  });
}

// 创建发货单详情
export function queryDeliveryOrderData(id) {
  return request({
    url: "/mes/mesDeliveryOrder/queryDeliveryOrderData/" + id,
    method: "GET"
  });
}

// 获取子箱唛
export function getCarton(purchaseOrderId, currentPageMaxCarton) {
  return request({
    url: "/mes/mesDeliveryOrder/getCarton/" + purchaseOrderId + "/" + currentPageMaxCarton,
    method: "GET"
  });
}

// 获取车缝后整时效录入
export function getSewingTime(purchaseOrderId) {
  return request({
    url: "/mes/mesDeliveryOrder/getSewingTime/" + purchaseOrderId,
    method: "GET"
  });
}

// 保存更新-车缝后整时效录入
export function updateSewingTime(data) {
  return request({
    url: "/mes/mesDeliveryOrder/updateSewingTime",
    method: "POST",
    data: data
  });
}

// 生成囤货码
export function generateCode(data) {
  return request({
    url: "/mes/mesPurchaseOrderErpSyn/generateCode",
    method: "POST",
    data: data
  });
}

// 关单
export function closeOrder(data, type) {
  return request({
    url: "/mes/mesPurchaseOrderClose/closeOrder?type=" + type,
    method: "POST",
    data: data
  });
}

// 关单-审批结果记录
export function getCloseOrderApproveRecord(purchaseOrderId) {
  return request({
    url: "/mes/mesPurchaseOrderClose/getCloseOrderApproveRecord/" + purchaseOrderId,
    method: "GET"
  });
}

// 提交或保存发货单
export function createDeliveryOrder(data) {
  return request({
    url: "/mes/mesDeliveryOrder/createDeliveryOrder",
    method: "POST",
    data: data
  });
}

// 收货查询-单据状态统计 （签收中、收货中、质检中、已入库）
export function getDeliverStateCount(id) {
  return request({
    url: "/mes/mesReceiving/getDeliverStateCount",
    method: "GET"
  });
}

// 收获查询列表
export function deliveryOrderPage(data) {
  return request({
    url: "/mes/mesReceiving/deliveryOrderPage",
    method: "POST",
    data: data
  });
}

// 扫码枪获取尺码
export function getSizeByErpStockCode(data, purchaseOrderCode) {
  return request({
    url: "/mes/mesDeliveryOrder/getSizeByErpStockCode/" + purchaseOrderCode,
    method: "POST",
    data: data
  });
}

// 根据采购单id打印箱唛
export function printPurchaseCartonLabelCode(data) {
  return request({
    url: "/mes/mesPurchaseOrderPrint/printPurchaseCartonLabelCode",
    method: "POST",
    data: data
  });
}